import React from "react"
import { navigationLogoBig } from "../../../../../static/svgs/navigation"

type Props = {
  onClick: () => void
}

const NavigationLogo = ({ onClick }: Props) => (
  <img
    alt="nanofind-logo"
    className="pl-3 cursor-pointer"
    onClick={onClick}
    src={navigationLogoBig}
  />
)

export default NavigationLogo
